import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import authentication from './modules/authentication'
import ui from './modules/ui'
import employees from './modules/employees'
import dashboard from './modules/dashboard'
import masters from './modules/masters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth:authentication,
    uicomponents:ui,
    employees:employees,
    dashboard:dashboard,
    masters:masters,
  },
  state: {
    layout: '',
    locale: null,
    currentLanguage: 'en',
    containerClass: '',
    loggedin: false,
    dashboardTitle: 'Dash Board',
    menuData:null,
    actionType:null,
    masterType:null,
    masterTypeName:null,
    serviceTypeName:null
  },
  actions,
  mutations,
  getters
})
export function createStore() {
  return store
}
//  For inheriting in other modules
export default store


// WEBPACK FOOTER //
// ./src/store/index.js